import React, { PureComponent, Fragment } from 'react';
import { string, arrayOf } from 'prop-types';
import classnames from 'classnames';
import { crumbShape } from 'shapes';
import Crumb from './Crumb/Crumb';
import './Breadcrumb.scss';

export default class Breadcrumb extends PureComponent {
    static propTypes = {
        className: string,
        crumbs: arrayOf(crumbShape).isRequired,
    };

    static defaultProps = {
        className: null,
    };

    render() {
        const { crumbs, className } = this.props;
        const rootClassnames = classnames(
            'instant-search__breadcrumb breadcrumb-root',
            className,
        );

        return (
            <div className={rootClassnames}>
                <div className="breadcrumb-wrapper">
                    {crumbs.map((crumb, index) => (
                        <Fragment key={crumb.id}>
                            <Crumb
                                crumb={crumb}
                                active={index === crumbs.length - 1}
                            />
                            {crumbs.length !== index + 1 && (
                                <span className="breadcrumb-root__separator">
                                    &gt;
                                </span>
                            )}
                        </Fragment>
                    ))}
                </div>
            </div>
        );
    }
}
